<template>
    <div>
        <header>
            <span class="font-8">
                Define Exceptions
            </span>
            <p class="font-5">
                Set exceptions for your defined ad units to customize the ad delivery for this segment.
            </p>
        </header>
        <SegmentException
            v-for="(item, adUnitId) in listData"
            :key="adUnitId"
            :adUnit="getAdUnitNameById(adUnitId)"
            :isActive="item.active"
            :placements="item.placements"
            :exceptions="item.exceptions"
            :supportsReward="parseInt(adUnitId) === adUnitIds.rewardedVideo"
            @editReward="$emit('editReward', $event)"
            @addCapping="$emit('addCapping', $event)"
            @editCapping="$emit('editCapping', $event)"
            @update:isActive="$emit('toggleActive', { adUnit: getAdUnitNameById(adUnitId), value: $event })"
        />
    </div>
</template>

<script>
import SegmentException from '@/pages/monetize/segments/segmentForm/SegmentException.vue';
import consts from 'services/metaData/consts';
import { adUnitIds } from 'services/utils/adUnitsMap';
import { invert, mapValues, pick } from 'lodash';

export default {
    name: 'SegmentExceptions',
    components: { SegmentException },
    props: {
        placementsData: {
            type: Object,
            required: true
        },
        exceptionsData: {
            type: Object,
            default: () => ({})
        },
        supportedAdUnits: {
            type: Array,
            default: () => [],
            validator: (val) => val.every((adUnit) => Object.keys(consts.ADUNIT_TO_NAME).includes(adUnit))
        },
        deliveryEnabled: {
            type: Object,
            validator: (val) => Object.keys(val).every((adUnit) => Object.keys(consts.ADUNIT_TO_NAME).includes(adUnit))
        }
    },
    computed: {
        listData() {
            const supportedIds = this.supportedAdUnits.map((a) => adUnitIds[a]);
            const supportedPlacements = pick(this.placementsData, supportedIds);
            return mapValues(supportedPlacements, (placements, adUnitId) => {
                const adUnit = this.getAdUnitNameById(adUnitId);
                return {
                    active: this.deliveryEnabled[adUnit] || false,
                    exceptions: this.exceptionsData[adUnit] || [],
                    placements
                };
            });
        },
        consts: () => consts,
        adUnitIds: () => adUnitIds
    },
    methods: {
        getAdUnitNameById(adUnitId) {
            const names = invert(adUnitIds);
            return names[adUnitId] || '';
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";
header {
    color: $light-900;
    line-height: 17px;
    p {
        margin: 0 0 21px;
    }
}
</style>
